import {Injectable} from '@angular/core';

@Injectable()
export class KeyCloakConfig {
  public static getConfig(): IKeyCloakConfig{
    const cfg = window['keycloackConfig']
    return cfg as IKeyCloakConfig
  }
}

export interface IKeyCloakConfig {
  isProductionEnv: boolean
  sslRequiredType: string
  url: string
  realm: string
  frontendClient: string
  frontendClientPublic: boolean
  useResourceRoleMapping: boolean
  confidentialPort: number
}



